import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage, FormattedNumber } from 'react-intl';

var SaveOffer =
/*#__PURE__*/
function (_Component) {
  _inherits(SaveOffer, _Component);

  function SaveOffer() {
    _classCallCheck(this, SaveOffer);

    return _possibleConstructorReturn(this, _getPrototypeOf(SaveOffer).apply(this, arguments));
  }

  _createClass(SaveOffer, [{
    key: "getPrice",
    value: function getPrice() {
      var _this$props = this.props,
          price = _this$props.price,
          currencyCode = _this$props.currencyCode;
      return React.createElement(FormattedNumber, {
        style: "currency",
        value: price,
        currency: currencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    }
  }, {
    key: "renderPlanName",
    value: function renderPlanName() {
      var credits = this.props.credits;
      return React.createElement("strong", null, React.createElement(FormattedMessage, {
        id: "save.offer.accepted.plan",
        defaultMessage: "{credits} credit/mo.",
        values: {
          credits: credits,
          price: this.getPrice()
        }
      }));
    }
  }, {
    key: "renderSaveOfferSuccess",
    value: function renderSaveOfferSuccess() {
      return React.createElement(Fragment, null, React.createElement("div", {
        className: "modal__header modal__header__img p++"
      }, React.createElement("h2", null, React.createElement(FormattedMessage, {
        id: "save.offer.accepted.header",
        defaultMessage: "You\u2019re Good to Go!"
      }))), React.createElement("p", {
        className: "m+"
      }, React.createElement(FormattedMessage, {
        id: "save.offer.accepted.details",
        defaultMessage: "Your membership change is confirmed, and your new {plan} plan will begin at the start of your next cycle.",
        values: {
          plan: this.renderPlanName()
        }
      })), React.createElement("p", {
        className: "text--center mb+"
      }, React.createElement("a", {
        href: "/classes",
        className: "bt bt--primary bt--solid bt--lg bt--width-lg",
        target: "_self"
      }, React.createElement(FormattedMessage, {
        id: "save.offer.accepted.book.class",
        defaultMessage: "Book a Class"
      }))));
    }
  }, {
    key: "renderSaveOffer",
    value: function renderSaveOffer() {
      var _this$props2 = this.props,
          credits = _this$props2.credits,
          loading = _this$props2.loading,
          name = _this$props2.name,
          onAccept = _this$props2.onAccept,
          rolloverCredits = _this$props2.rolloverCredits;
      return React.createElement(Fragment, null, React.createElement("div", {
        className: "modal__header modal__header__img p++"
      }, React.createElement("h2", null, React.createElement(FormattedMessage, {
        id: "save.offer.header",
        defaultMessage: "Looking for a better fit, {name}?",
        values: {
          name: name
        }
      }))), React.createElement("p", {
        className: "m+"
      }, React.createElement(FormattedMessage, {
        id: "save.offer.details",
        defaultMessage: "Our {plan} plan might work better for your schedule. Enjoy the same great ClassPass benefits you\u2019re used to: access to thousands of classes in any of our cities.",
        values: {
          plan: this.renderPlanName()
        }
      })), React.createElement("button", {
        className: classNames('bt bt--primary bt--lg mb+', {
          'bt--waiting': loading
        }),
        onClick: onAccept
      }, React.createElement(FormattedMessage, {
        id: "save.offer.accept",
        defaultMessage: "Yes, I want {credits} credits for {price}",
        values: {
          credits: credits,
          price: this.getPrice()
        }
      })), React.createElement("a", {
        className: "link--stealth text--small block mb+",
        href: "/settings/membership/update",
        target: "_self"
      }, React.createElement(FormattedMessage, {
        id: "save.offer.dismiss",
        defaultMessage: "I\u2019d rather cancel or take a break"
      })), React.createElement("p", {
        className: "text--sm text--light m+"
      }, React.createElement("em", null, React.createElement(FormattedMessage, {
        id: "save.offer.fine.print",
        defaultMessage: "Your {credits}\u200C credit/mo. plan for {price}\u200C begins at the start of your next billing cycle. Up to {rolloverCredits} credits will roll over automatically to your next month. You will automatically be charged each month for your new plan until you cancel, which you can do on the site at any time. By confirming your plan change, you agree to the ClassPass {terms} and {privacy}.",
        values: {
          credits: credits,
          rolloverCredits: rolloverCredits,
          price: this.getPrice(),
          privacy: React.createElement("a", {
            href: "/privacy"
          }, React.createElement(FormattedMessage, {
            id: "save.offer.fine.print.privacy",
            defaultMessage: "Privacy Policy"
          })),
          terms: React.createElement("a", {
            href: "/terms"
          }, React.createElement(FormattedMessage, {
            id: "save.offer.fine.print.terms",
            defaultMessage: "Terms of Use"
          }))
        }
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var planChangeSuccessful = this.props.planChangeSuccessful;
      var offer = this.renderSaveOffer();

      if (planChangeSuccessful) {
        offer = this.renderSaveOfferSuccess();
      }

      return offer;
    }
  }]);

  return SaveOffer;
}(Component);

SaveOffer.propTypes = {
  credits: PropTypes.number.isRequired,
  currencyCode: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  planChangeSuccessful: PropTypes.bool,
  price: PropTypes.number.isRequired,
  rolloverCredits: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  onAccept: PropTypes.func.isRequired
};
export { SaveOffer };